import { type FormEvent, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { AdminLoginRequest } from "@/lib/api/auth";

type LoginPageProps = {
  onLogin: (payload: AdminLoginRequest) => Promise<void>;
  busy: boolean;
  errorMessage: string | null;
  infoMessage: string | null;
};

export function LoginPage({
  onLogin,
  busy,
  errorMessage,
  infoMessage,
}: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (busy) return;
    await onLogin({
      username: username.trim(),
      password,
    });
  }

  return (
    <main className="login-page">
      <Card className="login-page__card">
        <CardHeader className="login-page__header">
          <p className="login-page__eyebrow">Area riservata</p>
          <CardTitle className="login-page__title">Console Documenti</CardTitle>
          <CardDescription className="login-page__description">
            Accedi con credenziali amministrative per gestire upload e
            monitoraggio delle analisi.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form
            className="login-form"
            onSubmit={(event) => void handleSubmit(event)}
          >
            <div className="upload-form__field upload-form__field--inline">
              <label className="upload-form__label" htmlFor="login-username">
                Username
              </label>
              <input
                id="login-username"
                className="upload-form__input"
                autoComplete="username"
                type="text"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                disabled={busy}
                required
              />
            </div>

            <div className="upload-form__field upload-form__field--inline">
              <label className="upload-form__label" htmlFor="login-password">
                Password
              </label>
              <input
                id="login-password"
                className="upload-form__input"
                autoComplete="current-password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={busy}
                required
              />
            </div>

            <Button
              className="upload-form__submit"
              type="submit"
              disabled={busy || !username.trim() || !password}
            >
              {busy ? "Accesso in corso..." : "Accedi"}
            </Button>

            <div aria-live="polite">
              {infoMessage ? (
                <p className="login-form__info">{infoMessage}</p>
              ) : null}
              {errorMessage ? (
                <p className="upload-form__error" role="alert">
                  Errore: {errorMessage}
                </p>
              ) : null}
            </div>
          </form>
        </CardContent>
      </Card>
    </main>
  );
}
